module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxMiA2NGMyNDcuNCAwIDQ0OCAyMDAuNiA0NDggNDQ4cy0yMDAuNiA0NDgtNDQ4IDQ0OFM2NCA3NTkuNCA2NCA1MTIgMjY0LjYgNjQgNTEyIDY0eiBtMTI4IDI4OGgtMjU2YTMyIDMyIDAgMCAwLTMxLjggMjguM0wzNTIgMzg0djI1NmEzMiAzMiAwIDAgMCAyOC4zIDMxLjhMMzg0IDY3MmgyNTZhMzIgMzIgMCAwIDAgMzEuOC0yOC4zTDY3MiA2NDB2LTI1NmEzMiAzMiAwIDAgMC0yOC4zLTMxLjhMNjQwIDM1MnoiIGZpbGw9IiMwIiBwLWlkPSI0MDYzIj48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Stop-filled.svg
// module id = mTNc
// module chunks = 74